import 'Styles/layout/theme.scss'
import '../snippets/match-media'
import '../snippets/mobile-nav'
import { Api } from '../snippets/api'
import * as cart from '../snippets/cart'
import $ from 'cash-dom'
import axios from 'axios'

const defaultFlag =
  'https://cdn.shopify.com/s/files/1/0278/9723/3501/files/globe.png?v=1681395819'

$(() => {
  const $els = {
    body: $('body, html'),
    searchOpen: $('.search-open'),
    searchClose: $('.search-close'),
    searchForm: $('.search-form'),
    searchFormInput: $('.search-form input'),
    cartToggle: $('.cart-toggle'),
    cartContentContainer: $('.cart-content-container'),
    cartContent: $('.cart-content'),
    cartClose: $('.cart-close'),
    lineItemRemove: $('.line-item-remove'),
    cookiesBanner: $('.cookies-banner'),
    cookiesClose: $('.cookies-banner-close'),
  }

  // Search
  $els.searchOpen.on('click', () => {
    $els.searchForm.removeClass('invisible opacity-0')
    setTimeout(() => {
      $els.searchFormInput.trigger('focus')
    }, 500)
  })
  $els.searchClose.on('click', () => {
    $els.searchForm.addClass('invisible opacity-0')
  })
  // $els.searchForm.on('submit', (e) => {
  //   e.preventDefault()
  //   const q = $(e.target).find('input').val()
  //   window.location.href = `${window.location.origin}/pages/search-results-1?q=${q}`
  // })

  // Cart icon
  $els.cartToggle.on('click', () => {
    const main = document.querySelector('main')
    if ($els.cartContentContainer.hasClass('visible')) {
      cart.closeCart()
      main.style.overflow = 'auto'
      main.style.height = 'auto'
    } else {
      cart.openCart()
      main.style.overflow = 'hidden'
      main.style.height = 'calc(100dvh - 30px)'
    }
  })

  // open cart if page view = cart
  const urlParams = new URLSearchParams(window.location.search)
  const view = urlParams.get('view')

  if (view === 'cart') {
    cart.openCart()
  }

  // Mobile nav open can close cart
  document.addEventListener('mobileNavOpened', () => {
    cart.closeCart()
  })

  // Intl trigger
  $('.js-intl-menu-trigger').on('click', (e) => {
    const $menu = $('.intl-menu')
    const $intl_menu = $(e.currentTarget)
    const $intl_menu_veil = $('.intl-menu__veil')
    const header = document.querySelector('.site-header')
    const isInverted = header.classList.contains('site-header--inverted')
    const main = document.querySelector('main')

    if (
      $menu.hasClass('active') &&
      window.scrollY <= 30 &&
      window.location.pathname === '/'
    ) {
      header.classList.add('site-header--inverted')
    }

    if (
      $menu.hasClass('active') ||
      $intl_menu.hasClass('active') ||
      $intl_menu_veil.hasClass('active')
    ) {
      // de-activate
      main.style.overflow = 'auto'
      main.style.height = 'auto'
      $menu.toggleClass('active')
      $intl_menu.toggleClass('active')
      $intl_menu_veil.toggleClass('active')
    } else {
      // activate
      main.style.overflow = 'hidden'
      main.style.height = 'calc(100dvh - 30px)'
      $menu.toggleClass('active')
      $intl_menu.toggleClass('active')
      $intl_menu_veil.toggleClass('active')
    }

    if (isInverted) {
      header.classList.remove('site-header--inverted')
    }
  })

  $('.intl-menu__link').on('click', (e) => {
    const country = $(e.currentTarget).data('country')
    localStorage.setItem('teddy-intl', country)
  })

  const fetchIntl = async () => {
    const endpoint =
      'https://teddy-baldassarre-watches.myshopify.com/api/2025-01/graphql.json'
    const token = '0172fb0ba8e0fc0685f8dc8a458ff088'
    const headers = { 'X-Shopify-Storefront-Access-Token': token }
    const query = `{
      shop {
        metafields(identifiers: [
          { key: "country_name", namespace: "intl" },
          { key: "country_flag", namespace: "intl" },
          { key: "country_iso", namespace: "intl" }
        ]) {
          key
          value
        }
      }
    }`
    const { data } = await axios.post(endpoint, { query }, { headers })
    const shop = data.data.shop
    const metafields = shop.metafields
    const getVal = (key) => metafields.find((m) => m.key === key).value
    const countryNames = JSON.parse(getVal('country_name')).filter(
      (v) => v !== 'United States'
    )
    const countryISOs = JSON.parse(getVal('country_iso')).filter(
      (v) => v !== ''
    )
    const countryFlags = getVal('country_flag')
    const flagUrls = JSON.parse(countryFlags).map((flag) => flag[0].src)
    const flagImgs = Array.from(document.querySelectorAll('.js-intl-flag'))
    const intlNames = Array.from(document.querySelectorAll('.js-intl-name'))

    let match = false
    countryISOs.forEach((iso, i) => {
      if (window.location.href.includes(`/${iso}`)) {
        const pathname = window.location.href.split(window.location.origin)[1]
        const currIso = pathname.split('/')[1]
        if (iso === currIso) {
          if (iso === 'en-int') {
            const country = localStorage.getItem('teddy-intl')
            const flags = flagUrls.filter((f) => !f.includes('tn_us-flag'))
            const idx = countryNames.indexOf(country)
            const flag = flags[idx]

            flagImgs.forEach((img) => {
              img.src = flag || defaultFlag
            })
            intlNames.forEach((name) => {
              name.innerHTML = country
            })
          } else {
            const country = countryNames[i]
            const flags = flagUrls.filter((f) => !f.includes('tn_us-flag'))
            const idx = countryNames.indexOf(country)
            const flag = flags[idx]

            localStorage.setItem('teddy-intl', country)

            flagImgs.forEach((img) => {
              img.src = flag
            })
            intlNames.forEach((name) => {
              name.innerHTML = country
            })
          }
        }
        match = true
      }
    })

    if (!match) {
      localStorage.setItem('teddy-intl', 'United States')
      flagImgs.forEach((img) => {
        const dataSrc = img.dataset.src
        img.src = dataSrc
      })
      intlNames.forEach((name) => {
        name.innerHTML = 'United States'
      })
    }
  }

  fetchIntl()

  // Gift Card redirect
  const currentURL = window.location.href
  if (
    currentURL.includes(
      '/tools/emails/click/gift-card-created/13/button/view-gift-card?'
    )
  ) {
    const newURL = document
      .getElementById('oe-link-container')
      .querySelector('a').innerText
    window.location.href = newURL
  }

  // Cart content
  $els.cartClose.on('click', () => {
    cart.closeCart()
  })

  $els.body.on('click', '.cart-item-remove', async (e) => {
    e.preventDefault()

    const item = e.currentTarget.closest('.cart-item')
    const subtotal = document.querySelector('.cart-subtotal')
    const itemPrice = item.querySelector('.cart-item-price p').innerText
    const subtotalPrice = subtotal.innerText
    const quantity = item.querySelector('.cart-item-quantity select').value

    var finalItemPrice = currency(itemPrice).multiply(quantity).divide(2)
    var fmtResult = currency(subtotalPrice)
      .subtract(finalItemPrice)
      .format()
      .replace('.00', '')

    subtotal.innerText = fmtResult
    item.remove()

    const id = $(e.currentTarget).data('id')
    await Api.removeProduct(id)
    const event = new CustomEvent('cartUpdated')
    document.dispatchEvent(event)
    cart.updateCart()
  })

  $els.body.on('change', '.cart-item-quantity select', async (e) => {
    const $this = $(e.currentTarget)
    const id = $this.data('id')
    const count = e.currentTarget.value
    const $num = e.currentTarget
      .closest('.cart-item-quantity')
      .querySelector('.caption')

    $num.innerHTML = count

    let subtotalPrice

    Array.from(document.querySelectorAll('.cart-items .cart-item')).forEach(
      (el) => {
        const itemPrice = el.querySelector('.cart-item-price p').innerText
        const quant = el.querySelector('.cart-item-quantity select').value
        const totalPrice = currency(itemPrice).multiply(quant)
        subtotalPrice = currency(totalPrice).add(subtotalPrice)
      }
    )

    const subtotal = document.querySelector('.cart-subtotal')
    subtotal.innerText = subtotalPrice.format().replace('.00', '')

    await Api.updateProduct(id, count)
    const event = new CustomEvent('cartUpdated')
    document.dispatchEvent(event)
    cart.updateCart()
  })

  // Main Nav Dropdown Menus

  const resetHeader = (header) => {
    const activeBanner = document.querySelector('.banner__content.active')

    if (activeBanner && activeBanner.dataset.headerStyle === 'solid_black') {
      if (!header.classList.contains('toggle--open'))
        header.classList.add('site-header--dark')
    } else if (
      activeBanner &&
      activeBanner.dataset.headerStyle === 'solid_white'
    ) {
      header.classList.remove('site-header--dark')
      header.classList.remove('site-header--inverted')
    } else {
      if (!header.classList.contains('toggle--open'))
        header.classList.add('site-header--inverted')
    }
  }

  $('.site-nav__link').on('mouseover', (e) => {
    const header = document.querySelector('.site-header')
    const parent = e.currentTarget.parentNode
    const hasMenu = parent.classList.contains('has-menu')

    if (hasMenu) {
      const menu = parent.querySelector('.nav-menu-container')
      const menuVeil = parent.querySelector('.nav-menu-veil')
      menu.setAttribute('open', true)
      menu.setAttribute('aria-hidden', false)
      e.currentTarget.setAttribute('aria-expanded', true)
      menuVeil.setAttribute('open', true)
    }

    if (!header.classList.contains('toggle--open'))
      header.classList.add('toggle--open')

    header.classList.remove('site-header--inverted')
    header.classList.remove('site-header--dark')
  })

  $('.site-nav__link').on('mouseout', (e) => {
    const parent = e.currentTarget.parentNode
    const hasMenu = parent.classList.contains('has-menu')
    const header = document.querySelector('.site-header')

    if (!hasMenu) {
      header.classList.remove('toggle--open')
      resetHeader(header)
      return
    }

    const menu = parent.querySelector('.nav-menu-container')
    const navLink = parent.querySelector('.site-nav__link')
    if (parent === e.relatedTarget.parentNode || !menu.matches(':hover')) {
      const menuVeil = parent.querySelector('.nav-menu-veil')
      menu.removeAttribute('open')
      menu.setAttribute('aria-hidden', true)
      navLink.setAttribute('aria-expanded', false)
      menuVeil.removeAttribute('open')
      resetHeader(header)
    } else {
      header.classList.remove('site-header--inverted')
      header.classList.remove('site-header--dark')
    }
  })

  // biome-ignore lint/complexity/useArrowFunction: <explanation>
  $('.nav-menu-container').on('mouseout', function (e) {
    if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) {
      return
    }
    const parent = e.currentTarget.parentNode
    const menu = e.currentTarget
    const menuVeil = parent.querySelector('.nav-menu-veil')
    const header = document.querySelector('.site-header')

    menu.removeAttribute('open')
    menu.setAttribute('aria-hidden', true)
    menuVeil.removeAttribute('open')
    if (!header.classList.contains('cart--open'))
      header.classList.remove('toggle--open')
    resetHeader(header)
  })

  $('.site-nav__link').on('keydown', (e) => {
    const parent = e.target.parentElement
    const hasMenu = parent.classList.contains('has-menu')
    if (e.which === 13 && hasMenu) {
      e.preventDefault()
      const menu = parent.querySelector('.nav-menu-container')
      const menuVeil = parent.querySelector('.nav-menu-veil')
      menu.removeAttribute('open')
      menuVeil.removeAttribute('open')

      // Set up the focus trap
      setupFocusTrap(menuContainer)
    }
  })

  $('.site-nav__link').on('focus', (e) => {
    const header = document.querySelector('.site-header')
    const parent = e.currentTarget.parentNode
    const hasMenu = parent.classList.contains('has-menu')

    if (hasMenu) {
      const menu = parent.querySelector('.nav-menu-container')
      const menuVeil = parent.querySelector('.nav-menu-veil')
      menu.setAttribute('open', true)
      menu.setAttribute('aria-hidden', false)
      e.currentTarget.setAttribute('aria-expanded', true)
      menuVeil.setAttribute('open', true)
    }

    if (!header.classList.contains('toggle--open'))
      header.classList.add('toggle--open')

    header.classList.remove('site-header--inverted')
    header.classList.remove('site-header--dark')
  })

  $('.site-nav__link').on('focusout', (e) => {
    const parent = e.currentTarget.parentNode
    if (!parent.contains(e.relatedTarget)) {
      const hasMenu = parent.classList.contains('has-menu')
      const header = document.querySelector('.site-header')

      if (!hasMenu) {
        header.classList.remove('toggle--open')
        resetHeader(header)
        return
      }

      const menu = parent.querySelector('.nav-menu-container')
      const navLink = parent.querySelector('.site-nav__link')
      if (parent === e.relatedTarget.parentNode || !menu.matches(':hover')) {
        const menuVeil = parent.querySelector('.nav-menu-veil')
        menu.removeAttribute('open')
        menu.setAttribute('aria-hidden', true)
        navLink.setAttribute('aria-expanded', false)
        menuVeil.removeAttribute('open')
        resetHeader(header)
      } else {
        header.classList.remove('site-header--inverted')
        header.classList.remove('site-header--dark')
      }
    }
  })

  $('.nav-menu-container').on('focusout', function (e) {
    if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) {
      return
    }
    const parent = e.currentTarget.parentNode
    const menu = e.currentTarget
    const menuVeil = parent.querySelector('.nav-menu-veil')
    const header = document.querySelector('.site-header')
    const navLink = parent.querySelector('.site-nav__link')

    menu.removeAttribute('open')
    menu.setAttribute('aria-hidden', true)
    navLink.setAttribute('aria-expanded', false)
    menuVeil.removeAttribute('open')
    if (!header.classList.contains('cart--open'))
      header.classList.remove('toggle--open')
    resetHeader(header)
  })

  function setupFocusTrap(container) {
    const focusableElementsString =
      'a[href], button:not([disabled]), [tabindex="0"]'
    const focusableElements = container.querySelectorAll(
      focusableElementsString
    )
    const firstFocusableElement = focusableElements[0]
    const lastFocusableElement = focusableElements[focusableElements.length - 1]

    function trapFocus(e) {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9
      let isEscPressed = e.key === 'Escape' || e.keyCode === 27

      if (isEscPressed) {
        // Close the menu when Escape key is pressed
        if (container.hasAttribute('open')) {
          container.removeAttribute('open')
        }
        return
      }

      if (!isTabPressed) {
        return
      }

      if (e.shiftKey) {
        /* shift + tab */ if (
          document.activeElement === firstFocusableElement
        ) {
          lastFocusableElement.focus()
          e.preventDefault()
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus()
          e.preventDefault()
        }
      }
    }

    // Attach the event listener to trap focus
    container.addEventListener('keydown', trapFocus)

    // Initially focus the first focusable element
    firstFocusableElement.focus()
  }

  $('.trigger-live-chat').on('click', () => {
    LiveChatWidget.call('maximize')
  })

  cart.updateCart()
})
